import { render, staticRenderFns } from "./TextMenu.vue?vue&type=template&id=0f5a7d10&"
import script from "./TextMenu.vue?vue&type=script&lang=js&"
export * from "./TextMenu.vue?vue&type=script&lang=js&"
import style0 from "./TextMenu.vue?vue&type=style&index=0&id=0f5a7d10&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports